import TCS_LETTERHEAD_URL from "../../../assets/icon/TCS_letterhead.png";
import ST_LETTERHEAD_URL from "../../../assets/icon/ST_letterhead.png";
import {
  DEFAULT_SALARY_COMPANY_NAME,
  isTheCodingStudioCompanyName,
} from "../company/financeDefaultSalaryCompany";

export const PAYSLIP_LETTERHEAD_KEYS = {
  TCS: "tcs",
  SATTVA: "sattva",
};

const normalizeName = (value) => String(value || "").trim().toLowerCase();

/** Which letterhead asset to use for a finance / payslip company name. */
export const getPayslipLetterheadKey = (companyName) => {
  const name = normalizeName(companyName);
  if (!name || isTheCodingStudioCompanyName(companyName)) {
    return PAYSLIP_LETTERHEAD_KEYS.TCS;
  }
  if (name.includes("sattva")) {
    return PAYSLIP_LETTERHEAD_KEYS.SATTVA;
  }
  return PAYSLIP_LETTERHEAD_KEYS.TCS;
};

export const getPayslipLetterheadUrl = (companyOrName) => {
  const companyName =
    typeof companyOrName === "string"
      ? companyOrName
      : companyOrName?.companyName || "";
  const key = getPayslipLetterheadKey(companyName);
  return key === PAYSLIP_LETTERHEAD_KEYS.SATTVA ? ST_LETTERHEAD_URL : TCS_LETTERHEAD_URL;
};

export const getPayslipLetterheadLabel = (companyOrName) => {
  const key = getPayslipLetterheadKey(
    typeof companyOrName === "string" ? companyOrName : companyOrName?.companyName
  );
  return key === PAYSLIP_LETTERHEAD_KEYS.SATTVA ? "Sattva Tech" : DEFAULT_SALARY_COMPANY_NAME;
};
